import { Component, HostListener, Input, OnInit } from '@angular/core';
import { GenericService } from "../../../../services/generic.service";
import { RubricMode } from "../../../../shared/classes/la-rubric";
import { menuPermissions } from "../../../../services/session.service";

@Component({
    selector: 'app-create-new',
    templateUrl: './create-new.component.html',
    styleUrls: ['./create-new.component.scss'],
    standalone: false
})
export class CreateNewComponent implements OnInit {
  @Input() canShowMenu: menuPermissions;

  menuOpen: boolean = false;
  readonly RubricMode = RubricMode;

  @HostListener('document:click', ['$event'])
  click(event) {
    if(
      !this.genericService.isDescendant("newMenu", event.target)  &&
      !event.target.classList.contains("submenu")
    ) {
      this.menuOpen = false;
    }
  }
  constructor(
    private genericService: GenericService
  ) { }

  ngOnInit() {
  }

  toggleMenuOpen(e) {
    e.preventDefault();
    this.menuOpen = !this.menuOpen;
  }
}
